<template>
  <VContainer>
    <VRow justify="center">
      <VCol cols="12" md="8">
        <VCard elevation="1" class="pa-3 pa-md-7 px-md-12 mb-5">
          <p align="center">
            <strong>Правила оказания услуг {{ APP_NAME }}</strong>
          </p>
          <p>
            Настоящий документ является предложением ООО "Бозон" заключить договор оказания услуг на нижеизложенных условиях с любым
            заинтересованным лицом. Настоящий документ является публичной офертой в соответствии со
            ст.437 Гражданского кодекса Российской Федерации.
          </p>
          <p align="center">
            <strong>1. Общие положения</strong>
          </p>
          <p>
            1.1. В целях настоящих Правил нижеприведенные термины используются в следующем значении:
          </p>
          <p>
            <strong>Правила </strong>
            – настоящий документ «Правила оказания услуг {{ APP_NAME }}», размещенный в сети Интернет
            по адресу:
            <a :href="`https://${HOME_DOMAIN}/`">https://{{ HOME_DOMAIN }}/</a>.
          </p>
          <p>
            <strong>Исполнитель </strong>
            – ООО "Бозон", выступающее в качестве исполнителя по договору оказания услуг.
          </p>
          <p>
            <strong>Заказчик</strong>
            – лицо, обладающее полной дееспособностью, заказывающее Услуги, предоставляемые
            Исполнителем.
          </p>
          <p>
            <strong>Стороны </strong>
            – Исполнитель и Заказчик при совместном упоминании.
          </p>
          <p>
            <strong>Услуги </strong>
            – информационные услуги по предоставлению доступа Заказчику к функциональным
            возможностям Сервиса по автоматизации подбора сотрудников.
          </p>
          <p>
            <strong>Договор</strong>
            – договор оказания информационных услуг по предоставлению доступа Заказчику к
            функциональным возможностям Сервиса по автоматизации подбора сотрудников, который
            заключается между Исполнителем и Заказчиком посредством акцепта оферты.
          </p>
          <p>
            <strong>Отклик</strong>
            – резюме Кандидата, который прошел квалификационный отбор, произведенный с
            использованием Сервиса (телефонного разговора, Интервью, иных средств коммуникации), и
            подтвердил интерес к вакансии
          </p>
          <p>
            <strong>Заказ</strong>
            – совершение Заказчиком следующих действий, необходимых для оформления отдельного
            Договора: выбор одного из тарифов, указанных на соответствующей странице Сайта или
            Личного кабинета Заказчика; направление Заказчиком требуемых условий оказания Услуг в
            соответствии с тарифами на адрес электронной почты Исполнителя, указанный в настоящих
            Правилах.
          </p>
          <p>
            <strong>Оферта</strong>
            – оформляемое на основании Заказа предложение Исполнителя о заключении Договора,
            выражаемое путем выставления счета на оплату Услуг либо направления Заказа на оплату
            через платежную систему с использованием Личного кабинета Заказчика.
          </p>
          <p>
            1.2. Термины, значение которых не раскрывается в настоящем разделе, имеют значение,
            приписанное им в Пользовательском соглашении.
          </p>
          <p align="center">
            <strong>2. Общие положения</strong>
          </p>
          <p>
            2.1. Каждая из Сторон гарантирует, что обладает необходимой право- и дееспособностью, а
            равно всеми правами и полномочиями, необходимыми и достаточными для заключения и
            исполнения Договора.
          </p>
          <p>
            2.2. Предложение о заключении Договора является бессрочным и действует в течение всего
            времени размещения текста Правил на Сайте.
          </p>
          <p>
            2.3. Акцепт оферты, произведенный Заказчиком, до истечения срока акцепта, создает
            договор на условиях настоящего документа.
          </p>
          <p>
            2.4. Настоящим Заказчик соглашается с тем, что факт выполнения определенных действий на
            Сайте, в том числе, выполнение команд через интерфейс (нажатие кнопок, клики) и иные
            подобные действия, означают волеизъявление Заказчика в отношении заказа Услуг в
            соответствии с указанными на Сайте параметрами, ценой и сроками.
          </p>
          <p>
            2.5. Заказчик должен ознакомиться с действующей редакцией Правил, размещенной на Сайте
            до заключения Договора.
          </p>
          <p>
            2.6. Настоящим Заказчик подтверждает, что акцепт (совершение действий по принятию
            Оферты) равносилен подписанию и заключению договора на условиях, изложенных в настоящем
            документе. При этом договор как бумажный документ, подписанный обеими Сторонами, не
            оформляется. Такой порядок заключения сделки признается соблюдением простой письменной
            формы договора.
          </p>
          <p>
            2.7. Осуществляя акцепт оферты, Заказчик, для целей исполнения настоящего Договора, дает
            Исполнителю согласие на сбор и обработку персональных данных в соответствии с Политикой
            конфиденциальности.
          </p>
          <p>
            2.8. В соответствии с пунктом 3 статьи 438 Гражданского кодекса Российской Федерации
            (далее – ГК РФ) оплата Заказчиком Услуг в сумме, указанной Исполнителем в счете/Личном
            кабинете, является акцептом Оферты.
          </p>
          <p>
            2.9. Таким образом, Договор между Исполнителем и Заказчиком считается заключенным с
            момента оплаты Заказчиком Услуг. При этом, каждый Заказ Услуг в рамках Договора является
            самостоятельным соглашением на оказание Услуг. Такое соглашение может быть заключено в
            отношении Услуг, доступных для заказа и оплаты в момент обращения Заказчика к Сайту.
          </p>
          <p>
            2.10. Во избежание сомнений использование Заказчиком Услуг дополнительно свидетельствует
            о заключении Договора на их оказание в соответствии с условиями настоящих Правил.
          </p>
          <p>
            2.11. На основании настоящих Правил с Заказчиком может быть заключено неограниченное
            количество Договоров.
          </p>
          <p>
            2.12. Правила вступают в силу с момента размещения на Сайте и действуют до момента их
            отмены Исполнителем. Исполнитель оставляет за собой право вносить изменения в текст
            настоящей Правил без специального уведомления об этом Заказчика путем публикации новой
            редакции. Новая редакция Правил вступает в силу с момента ее размещения на Сайте, если
            иное не предусмотрено новой редакцией.
          </p>
          <p>
            2.13. Заказчик обязан регулярно отслеживать изменения, вносимые в Правила. В случае если
            после вступления в действие новой редакции Правил Заказчик продолжает использовать
            Услуги, то Заказчик тем самым подтверждает свое полное согласие с новой редакцией
            Правил.
          </p>
          <p>
            2.14. Использование Сервиса должно осуществляться Заказчиком исключительно для целей
            подбора сотрудников с соблюдением положений настоящих Правил и Пользовательского
            Соглашения, а равно требований законодательства. В частности, Заказчику запрещается:
            сбор и использование информации о Кандидатах в иных целях, помимо подбора персонала;
            распространение рекламной и иной информации, не связанной с подбором персонала;
            распространение недостоверной информации, а также информации, порочащей честь
            достоинство или деловую репутацию третьих лиц; совершение действий, унижающих честь и
            достоинство других лиц; совершение иных противоправных действий, включая получение
            несанкционированного доступа к конфиденциальной информации, ее распространение,
            неправомерный доступ к компьютерной информации, использование и распространение
            вредоносных программ.
          </p>
          <p align="center">
            <strong>3. Предмет Договора</strong>
          </p>
          <p>
            3.1. Договор определяет отношения, возникающие между Исполнителем и Заказчиком в связи с
            оказанием Услуг.
          </p>
          <p>
            3.2. Заказчик подтверждает, что до момента заключения Договора (акцепта оферты) получил
            полную информацию о порядке оказания Услуг.
          </p>
          <p>
            3.3. Исполнитель при наличии технической возможности в соответствии с настоящими
            Правилами и Пользовательским соглашением обязуется за вознаграждение оказывать Заказчику
            услуги на основании размещенных Заказов, а Заказчик обязуется оплачивать и принимать
            данные Услуги.
          </p>
          <p>
            3.4. Наименование, состав и стоимость Услуг, а также прочие необходимые условия Договора
            определяются на основании сведений и материалов, предоставленных Заказчиком при
            оформлении Заказа.
          </p>
          <p>
            3.5. Параметры Услуг указываются в счете, выставляемом Исполнителем, и считаются
            согласованными при его оплате Заказчиком.
          </p>
          <p>
            3.6. Обязательным условием оказания Исполнителем Услуг является принятие Заказчиком
            Политики конфиденциальности и Пользовательского соглашения, размещенных на Сайте.
          </p>
          <p align="center">
            <strong>4. Порядок оказания услуг</strong>
          </p>
          <p>
            4.1. Список доступных для заказа Услуг и их стоимость может изменяться Исполнителем в
            одностороннем порядке, в т.ч. без внесения изменений в текст Правил.
          </p>
          <p>
            4.2. Обязательства Исполнителя по предоставлению Услуг являются встречными по отношению
            к обязательствам Заказчика по оплате Услуг. В случае невыполнения Заказчиком данных
            обязательств Исполнитель вправе приостановить или отказаться от оказания Услуг в
            соответствующей части.
          </p>
          <p>
            4.3. Оказание Услуг начинается в течение одного рабочего дня с момента, когда Заказчик
            считается исполнившим свои обязательства по оплате Услуг.
          </p>
          <p>
            4.4. Срок оказания услуг соответствует оплаченному Заказчиком периоду оказания Услуг.
            Если иное не установлено на Сайте, периодом оказания услуг является 1 (один) месяц.
            Кроме того, для заказа доступны разовые Услуги, указанные в Личном кабинете.
          </p>
          <p>
            4.5. Услуги считаются оказанными Исполнителем с момента обеспечения возможности
            использования Заказчиком соответствующих функциональных возможностей Сервиса посредством
            открытия и резервирования доступа к ним Заказчика на соответствующий срок и/или в
            соответствующем объеме во внутренней учетной системе Исполнителя.
          </p>
          <p>
            4.6. При этом, пакет Услуг признается оказанным в полном объеме независимо от того,
            использовал ли Заказчик в полном объеме предусмотренные пакетом опции. Неиспользованные
            опции (например, звонки, SMS) сгорают после окончания соответствующего периода.
          </p>
          <p>
            4.7. Заказчик обязан знакомиться в Личном кабинете с информацией о заказанных и
            оказанных Услугах, составе и сроках предоставления доступа к функциональным возможностям
            Сервиса.
          </p>
          <p>
            4.8. Неоткрытые (неоплаченные) Интервью хранятся в Личном кабинете 60 (шестьдесят) дней,
            открытые – 180 (сто восемьдесят) дней.
          </p>
          <p>
            4.9. По окончании оказания Исполнитель формирует Универсальный передаточный документ об
            оказании услуг. (далее — «УПД»).
          </p>
          <p>
            4.10. Стороны признают и соглашаются, что сведения об оказанных Услугах указываются в
            УПД на основе данных внутренней учетной системы Исполнителя.
          </p>
          <p>
            4.11. УПД направляется Заказчику в электронном виде на адрес электронной почты Заказчика
            либо отображается в Личном кабинете Заказчика не позднее 10 (Десять) рабочих дней с даты
            его составления. Заказчик вправе получить копию УПД на бумажном носителе по месту
            нахождения Исполнителя, указанному настоящих Правилах.
          </p>
          <p>
            4.12. Заказчик обязан ознакомиться с УПД в электронной форме в течение 3 (Трех) рабочих
            дней с даты его доставки. В случае непредставления Заказчиком в течение срока для
            ознакомления с УПД Исполнителю письменных возражений по УПД, Услуги считаются принятыми
            Заказчиком в полном объеме. При этом УПД, подписанный со стороны Исполнителя, имеет
            полную юридическую силу.
          </p>
          <p>
            4.13. В случае невозможности использования Услуг по вине Исполнителя, Заказчик должен
            направить Исполнителю письменную претензию с подробным указанием обстоятельств и периода
            отсутствия доступа к функциональным возможностям Сервиса.
          </p>
          <p>
            4.14. В случае признания претензии обоснованной, доступ Заказчика к соответствующим
            функциональным возможностям Сервиса продлевается Исполнителем на объем (количество
            Откликов) или срок использования Сервиса, которые не могли быть использованы Заказчиком
            надлежащим образом по вине Исполнителя.
          </p>
          <p>
            4.15. В случаях нарушения Заказчиком каких-либо условий настоящих Правил или
            Пользовательского соглашения, Исполнитель вправе прекратить оказание Услуг без возврата
            денежных средств Заказчику и компенсации каких-либо убытков.
          </p>
          <p align="center">
            <strong>5. Обязательства Сторон</strong>
          </p>
          <p>5.1. <strong>Права Исполнителя:</strong></p>
          <p>
            5.1.1. Время от времени вносить изменения и/или дополнения в Правила.
          </p>
          <p>
            5.1.2. Привлекать третьих лиц для оказания Услуг, предусмотренных Договором, без
            дополнительного согласия Заказчика. В случае привлечения Исполнителем третьих лиц,
            Исполнитель несет ответственность перед Заказчиком за качество и своевременность Услуг,
            оказанных привлеченными третьими лицами, как за свои собственные.
          </p>
          <p>
            5.1.3. Не приступать к оказанию Услуг до их оплаты.
          </p>
          <p>
            5.1.4. Приостанавливать работу Сервиса для проведения профилактических работ.
          </p>
          <p>
            5.1.5. Приостанавливать оказание Услуг в случае нарушения Заказчиком требований,
            предусмотренных Правилами, Пользовательским соглашением и/или законодательством РФ.
          </p>
          <p>
            5.1.6. Осуществлять ограничение отдельных действий Заказчика, если такие действия
            создают угрозу для нормального функционирования Сервиса.
          </p>
          <p>
            <strong>5.2. Обязанности Исполнителя:</strong>
          </p>
          <p>
            <strong>5.2.1. </strong>
            Делать все возможное для обеспечения качественного и бесперебойного предоставления
            Услуг.
          </p>
          <p>
            5.2.2. Воздерживаться от каких-либо действий, способных затруднить осуществление
            Заказчиком прав, предоставленных ему Договором или действующим законодательством
            Российской Федерации.
          </p>
          <p>5.3. <strong>Права </strong>Заказчика:</p>
          <p>
            5.3.1. Оформлять заказы на оказание Услуг.
          </p>
          <p>
            5.3.2. Требовать от Исполнителя качественного предоставления услуг в соответствии с
            Договором.
          </p>
          <p>
            5.3.3. Пользоваться иными правами, предоставленными ему Договором и законодательством
            Российской Федерации.
          </p>
          <p>5.4. <strong>Обязанности</strong> Заказчика:</p>
          <p>
            5.4.1. Соблюдать при пользовании Услугами требования действующего законодательства
            Российской Федерации, положения настоящих Правил и Пользовательского соглашения.
          </p>
          <p>
            5.4.2. Не передавать свои права и обязанности по Договору третьим лицам.
          </p>
          <p>
            5.4.3. Принять и своевременно оплатить оказываемые услуги.
          </p>
          <p>
            5.4.4. Проверять наличие уведомлений Исполнителя на Сайте (в том числе, в Личном
            кабинете) и по электронному адресу, указанному Заказчиком, а также просматривать
            информацию о ходе оказания Услуг.
          </p>
          <p>
            5.4.5. Не нарушать имущественных и/или личных неимущественных прав третьих лиц, а равно
            запретов и ограничений, установленных применимым правом, включая авторские и смежные
            права, права на товарные знаки, знаки обслуживания, права на использование изображений
            граждан.
          </p>
          <p align="center">
            <strong>6. Порядок расчетов</strong>
          </p>
          <p>
            6.1. Цены указаны в интерфейсе Сайта, и могут быть изменены
            <strong>Исполнителем</strong> в одностороннем порядке без какого-либо специального
            предупреждения.
          </p>
          <p>
            6.2. Стоимость выбранной Заказчиком Услуги в рамках Договора определяется исходя из ее
            характеристик (вид Услуги, период оказания и иные параметры) и сообщается Заказчику
            посредством выставления счета или через интерфейс Сайта.
          </p>
          <p>
            6.3. Оплата Услуг производится на условиях 100% предоплаты.
          </p>
          <p>
            6.4. Все расчеты должны осуществляться в российских рублях.
          </p>
          <p>
            6.5. Заказчик считается исполнившим свои обязательства по оплате Услуг с момента
            поступления денежных средств на расчетный счет Исполнителя в установленном размере при
            безналичной форме оплаты либо предоставления информации о совершенном Заказчиком платеже
            оператором платежного сервиса, действующим на основании договора с Исполнителем.
          </p>
          <p>
            6.6. Исполнитель вправе предоставлять скидки (бесплатные периоды), условия применения
            которых указываются на Сайте.
          </p>
          <p>
            6.7. Возможен апгрейд тарифа в соответствии с параметрами, указанными в Личном кабинете.
          </p>
          <p align="center">
            <strong>7. Бонусная программа</strong>
          </p>
          <p>
            7.1. Если Заказчик привязывает банковскую карту для рекуррентных платежей (для тарифа
            «Малый бизнес»), то каждый месяц он получает 20% от суммы платежа в виде бонусных
            баллов.
          </p>
          <p>
            7.2. При пополнении баланса за период более 1 (одного) месяца по тарифу Заказчику
            начисляются бонусные баллы, которые можно расходовать на оплату разовых услуг
            (откликов), продление или апгрейд тарифа. При этом, сначала расходуются реальные рубли,
            потом бонусные баллы.
          </p>
          <p>
            7.2.1. Размер бонусных баллов:
          </p>
          <ul>
            <li>
              при оплате за 3 месяца – 5%;
            </li>
            <li>
              при оплате за 6 месяцев – 10%;
            </li>
            <li>
              при оплате за 9 месяцев – 20%;
            </li>
            <li>
              при оплате за 12 месяцев – 30%.
            </li>
          </ul>
          <p>
            7.2.2. Заказчик сохраняет максимальный процент начисляемых бонусных баллов на каждый
            следующий платёж при условии, что обслуживание идёт без перерыва.
          </p>
          <p>
            7.3. Заказчику начисляется 7500 бонусных баллов, если по его приглашению
            зарегистрировался новый пользователь и оплатил тариф за период не менее 1 (одного)
            месяца.
          </p>
          <p>
            7.3.1. Заказчику запрещается:
          </p>
          <p>
            · Создавать множественные аккаунты на Сайте;
          </p>
          <p>
            · Привлекать пользователей способами, противоречащими законодательству;
          </p>
          <p>
            · Осуществлять спам в электронных письмах, социальных сетях, мессенджерах;
          </p>
          <p>
            · Использовать технологии cookiestuffing (cookiedropping), изменять, осуществлять
            подмену cookies посетителя на другие, в том числе, с помощью использования pop-up,
            iframe.
          </p>
          <p>
            · Регистрировать и/или использовать для продвижения домены, сходные с доменами Сайта
            Исполнителя.
          </p>
          <p>
            7.4. При выявлении нарушений Правил учетная запись Заказчика блокируется без возврата
            денежных средств, все начисленные бонусные баллы аннулируются.
          </p>
          <p align="center">
            <strong>8. Ответственность сторон </strong>
          </p>
          <p>
            8.1 В случае неисполнения или ненадлежащего исполнения своих обязательств по Договору
            Стороны несут ответственность в соответствии с действующим законодательством Российской
            Федерации и условиями Договора.
          </p>
          <p>
            8.2 Стороны освобождаются от ответственности за невыполнение в отношении исполнения
            любого из обязательств в той мере и в том случае, если подобное невыполнение было
            вызвано любым чрезвычайным событием, находящимся вне контроля затронутой стороной (что
            включает в себя, в том числе, стихийные бедствия, войны, террористические акты,
            гражданские беспорядки, забастовки, решения органов государственной власти,
            препятствующие выполнению настоящего Договора, в том числе, действия или указания
            Роскомнадзора, блокировка Интернет-ресурсов по IP адресам или иным образом).
          </p>
          <p>
            8.3 Исполнитель не несет ответственности за работоспособность серверов; любые ошибки,
            технические сбои или иные проблемы любых сетей или служб, линий связи, компьютерных
            систем, провайдеров и программного обеспечения.
          </p>
          <p>
            8.4 Исполнитель не несет ответственности за несоответствие оказываемых Услуг
            потребностям или ожиданиям Заказчика. Такое несоответствие ожиданиям, потребностям не
            являются основаниями считать услуги оказанными некачественного или в несогласованном
            объеме. Исполнитель не дает гарантий нахождения сотрудников.
          </p>
          <p>
            8.5 Ответственность Исполнителя по Договору в любом случае ограничивается возмещением
            причиненного Заказчику реального ущерба в сумме, не превышающей оплаченную стоимость
            Услуг по соответствующему Договору.
          </p>
          <p>
            8.6 Исполнитель не обязан осуществлять проверку содержания, подлинности и безопасности
            информации, размещаемой или предоставляемой Заказчиком, а также проверку ее соответствия
            требованиям законодательства и наличия у Заказчика необходимого объема прав на ее
            распространение или использование.
          </p>
          <p>
            8.7 Заказчик самостоятельно в полном объеме несет ответственность за содержание
            сообщений, направляемых через Сервис Кандидатам, а также действия, совершаемые с
            полученной информацией и материалами о Кандидатах; за соответствие размещаемой им
            информации и материалов требованиям законодательства, в том числе за их содержание и
            правомерность использования в них объектов интеллектуальной собственности.
          </p>
          <p>
            8.8 В случае если какое-либо третье лицо предъявляет Исполнителю претензию в отношении
            размещенной Заказчиком вакансии, Интервью либо в отношении прав на интеллектуальную
            собственность, иную претензию в связи с нарушением Заказчиком Пользовательского
            соглашения, настоящих Правил или законодательства, Заказчик обязуется незамедлительно по
            требованию Исполнителя предоставить ему всю запрашиваемую информацию, касающуюся
            предмета спора, и содействовать Исполнителю в урегулировании таких претензий, а также
            компенсировать Исполнителю все убытки (включая судебные расходы, расходы по уплате
            штрафов), связанные с такой претензией. Сумма убытков может быть удержана Исполнителем
            из денежных средств Заказчика, поступивших в счет оплаты Услуг по Договору.
          </p>
          <p align="center">
            <strong>9. Срок действия Договора</strong>
          </p>
          <p>
            9.1 Договор вступает в силу с момента акцепта Оферты Заказчиком (оплаты Услуг) и
            действует до момента полного исполнения Сторонами обязательств по Договору, либо до
            момента досрочного расторжения Договора.
          </p>
          <p>
            9.2 Договор может быть в любой момент расторгнут по соглашению Сторон. Также, любая из
            Сторон вправе в одностороннем внесудебном порядке отказаться от исполнения Договора,
            предварительно уведомив другую Сторону не менее чем за 30 (тридцать) дней до
            предполагаемой даты прекращения Договора. В случае отказа Заказчика от исполнения
            Договора после предоставления Заказчику приобретенного доступа к функциональным
            возможностям Сайта, стоимость соответствующих Услуг не возвращается.
          </p>
          <p>
            9.3 В случае нарушения Заказчиком условий Договора, настоящих Правил или
            Пользовательского соглашения Исполнитель вправе досрочно расторгнуть Договор. При этом,
            оставшаяся по Договору сумма удерживается в качестве штрафной неустойки в связи с
            допущенными нарушениями.
          </p>
          <p align="center">
            <strong>10. Рассмотрение претензий и порядок разрешения споров</strong>
          </p>
          <p>
            10.1 До обращения в суд Заказчик должен соблюсти внесудебный порядок разрешения споров,
            направив в адрес Исполнителя письменную претензию, с приложением документов,
            подтверждающих обстоятельства и требования, на которые ссылается Заказчик. Срок
            рассмотрения таких претензий составляет не более 30 (тридцати) дней с момента получения
            претензии Исполнителем, если более короткий срок не предусмотрен законодательством.
          </p>
          <p>
            10.2 Письменная претензия о ненадлежащем оказании Услуги должна содержать подробные
            указания на несоответствие оказанной Услуги положениям Договора, а также должна быть
            подтверждена документально, в том числе, путем приложения к претензии скриншотов,
            подтверждающих ненадлежащее оказание Услуги или ее неоказание. При этом скриншот не
            является неопровержимым доказательством ненадлежащего оказания Исполнителем Услуги.
          </p>
          <p>
            10.3 Споры, возникшие в рамках настоящей Договора, должны быть переданы на рассмотрение
            в суд в соответствии с действующим законодательством Российской Федерации.
          </p>
          <p align="center">
            <strong>11. Заключительные положения</strong>
          </p>
          <p>
            11.1. Договор выражает все договорные условия и понимание между Сторонами в отношении
            всех упомянутых здесь вопросов, при этом все предыдущие обсуждения, обещания,
            представления между сторонами, если таковые имелись, теряют силу и заменяются
            вышеизложенным текстом.
          </p>
          <p>
            11.2. Ничто в Договоре не может пониматься как установление между Заказчиком и
            Исполнителем агентских отношений, отношений по совместной деятельности либо каких-то
            иных отношений, прямо не предусмотренных Договором.
          </p>
          <p>
            11.3. При заключении, исполнении и расторжении Договора Стороны вправе передавать друг
            другу документы и сообщения с помощью средств электронной связи. Настоящим Стороны
            подтверждают, что документы и сообщения, направленные с адресов электронной почты
            Сторон, имеют юридическую силу для обеих сторон. Электронные сообщения и документы,
            направленные с помощью такого способа, считаются подписанными простой электронной
            подписью.
          </p>
          <p>
            11.4. Договор регулируется и толкуется в соответствии с законодательством Российской
            Федерации. Вопросы, не урегулированные настоящим Договором, подлежат разрешению в
            соответствии с законодательством Российской Федерации.
          </p>
          <p>
            11.5. Если по тем или иным причинам одно или несколько положений настоящего Договора
            будут признаны недействительными или не имеющими юридической силы, это не окажет влияния
            на действительность или применимость остальных положений Договора.
          </p>
          <p>
            11.6. Обращения, предложения и претензии к Исполнителю в связи с Договором, нарушениям
            прав и интересов третьих лиц, а также запросы уполномоченных законодательством лиц могут
            быть направлены по реквизитам, указанным в разделе 12 Правил.
          </p>
          <p align="center">
            <strong>12. Реквизиты Исполнителя</strong>
          </p>
          <p>
            ООО "Бозон"
          </p>
          <p>
            ОГРН: 1187746716563
          </p>
          <p>
            105066, г. Москва, вн.тер.г. Муниципальный Округ
            <br>
            Басманный, ул Доброслободская, д. 7/1 стр. 3, помещ. 3/2
          </p>
          <p>Еmail: <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a></p>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script>
import { HOME_DOMAIN, APP_NAME, SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'Rules',
  data() {
    return {
      HOME_DOMAIN,
      APP_NAME,
      SUPPORT_EMAIL,
      pageTitle: `Правила оказания услуг ${APP_NAME}`,
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  },
};
</script>
